import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class RoutingService {
    private readonly router = inject(Router);

    async navigateToEntries(): Promise<void> {
        await this.router.navigateByUrl('/weight-entries');
    }

    async navigateToEditEntry(entryId: string): Promise<void> {
        await this.router.navigate(['weight-entries', 'edit', entryId]);
    }

    async navigateToCreateEntry(): Promise<void> {
        await this.router.navigate(['weight-entries', 'create']);
    }

    async navigateToRabbits(): Promise<void> {
        await this.router.navigateByUrl('/rabbits');
    }

    async navigateToEditRabbit(entryId: string): Promise<void> {
        await this.router.navigate(['rabbits', 'edit', entryId]);
    }

    async navigateToCreateRabbit(): Promise<void> {
        await this.router.navigate(['rabbits', 'create']);
    }
}